export enum PasswordErrorType {
    Uppercase = 'passwordUppercaseValidator',
    Lowercase = 'passwordLowercaseValidator',
    Digit = 'passwordDigitValidator',
    Special = 'passwordSpecialValidator',
    Length = 'passwordLengthValidator',
    Default = 'passwordDefaultValidator'
}
